import React from 'react';

import TourGuide from 'src/components/Banners/TourGuide';
import Facts from '../../containers/Facts';
import AboutHotel from '../../containers/AboutHotel';
import ExtraItems from '../../containers/ExtraItemsContainer';
import Container from '../Container';
import Paper from '../Paper';
import PaperSeparator from '../Paper/PaperSeparator';
import EmptyAboutHotel from './EmptyAboutHotel';
import LastReview from '../Reviews/OldReviewsComponents/LastReview';

interface HotelInfoMobileProps {
  hasRating: boolean;
  isLastReview: boolean;
  hasFacts: boolean;
  hasAboutHotel: boolean;
  hasExtraItems: boolean;
  isHotelOnly: boolean;
  isNewReviewsVariant: boolean;
}

const HotelInfoMobile = ({
  hasRating,
  isLastReview,
  hasFacts,
  hasAboutHotel,
  hasExtraItems,
  isHotelOnly,
  isNewReviewsVariant,
}: HotelInfoMobileProps) => (
  <>
    {/* факты и только на лт */}
    {(hasFacts || hasExtraItems) && (
      <Container isMobile>
        <Paper padding={10}>
          {hasFacts && (
            <>
              <Facts isMobile />
              {hasExtraItems && !isHotelOnly && <PaperSeparator margin={10} />}
            </>
          )}
          <ExtraItems />
        </Paper>
      </Container>
    )}
    {!isHotelOnly && (
      <Container isMobile>
        <TourGuide isMobile />
      </Container>
    )}
    {/* trust you и отзывы */}
    {isLastReview && !isNewReviewsVariant && (
      <Container isMobile>
        <Paper padding={10}>{isLastReview && <LastReview isMobile />}</Paper>
      </Container>
    )}
    {/* Об отеле */}
    {hasAboutHotel && (
      <Container isMobile>
        <Paper padding={10}>
          <AboutHotel isMobile />
        </Paper>
      </Container>
    )}
    {!hasAboutHotel && !hasFacts && !hasRating && !isLastReview && (
      <EmptyAboutHotel isMobile />
    )}
  </>
);

export default React.memo(HotelInfoMobile);
